import script from "./ProductSelectionBar.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductSelectionBar.vue?vue&type=script&setup=true&lang=js"

import "./ProductSelectionBar.vue?vue&type=style&index=0&id=a61ae87e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a61ae87e"]])

export default __exports__